import React from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { toastError, toastSuccess } from '../../shared/toastr'
import { AccountApi } from '../../services/AccountApi'
import { useOfferionTranslation } from '../../shared/store/hooks/useOfferionTranslation'
import { Button } from '../shared/Button'
import { BackgroundBlockPattern } from '../shared/GridBackground'
import { FormInput } from '../shared/form/FormInput'
import { BackToLoginLink } from '../components/ui/back-to-login-link'
import { FormField } from '../shared/form/FormField'

export const ForgotPasswordContainer = () => {
    const { t } = useOfferionTranslation()

    const onSubmit = async ({ email }: { email: string }) => {
        try {
            await AccountApi.startResetPasswordProcess(email)

            toastSuccess('ForgotPassword.Message.InstructionsSent', { email })
        } catch (error) {
            console.error('Error in forgot password process', error)
            toastError('ForgotPassword.showErrorMessage')
        }
    }

    const schema = Yup.object().shape({
        email: Yup.string()
            .required(t('Allaround.Validation.required', { fieldName: t('Email') }))
            .email(t('Allaround.Validation.mail', { fieldName: t('Email') })),
    })

    return (
        <div className="bg-white w-full h-full flex flex-col justify-between">
            <BackToLoginLink />
            <main className="font-sans w-full h-full pt-12 sm:pt-16 md:pt-32 px-5">
                <div className="w-full md:bg-grey10  flex flex-col gap-8 max-w-[430px] mx-auto md:p-10 rounded-[14px] md:border md:border-border">
                    <span className="text-xl text-grey100">{t('ForgotPassword.pageTitle')}</span>
                    <Formik initialValues={{ email: '' }} onSubmit={onSubmit} validationSchema={schema}>
                        {_formikProps => {
                            return (
                                <Form noValidate={true}>
                                    <FormField
                                        component={FormInput}
                                        name="email"
                                        type="email"
                                        label={t('Login.email')}
                                        placeholder={t('Login.emailPlaceholder')}
                                    />

                                    <br />
                                    <Button>{t('ForgotPassword.resetPasswordButton')}</Button>
                                </Form>
                            )
                        }}
                    </Formik>
                </div>

                <BackgroundBlockPattern />
            </main>
        </div>
    )
}
